var _objectSpread = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var v1 = require('../cloudinary');

var api = require('./api');

var uploader = require('./uploader');

var search = require('./search');

var v2 = _objectSpread({}, v1, {
  api: api,
  uploader: uploader,
  search: search
});

module.exports = v2;